import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=6ab9cd1c&"
import script from "./VideosList.vue?vue&type=script&lang=ts&"
export * from "./VideosList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports